"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryData = void 0;
const StoryScreen_1 = require("./StoryScreen");
const uniqid = require("uniqid");
class StoryData {
    constructor(data) {
        this.logo = null;
        this.title = "";
        this.subtitle = "";
        this.position = 0;
        this.forward = false;
        this.screens = [];
        this.isSeen = false;
        this.hightlighted = false;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.logo = (typeof data.logo !== "undefined" && data.logo) ? `${data.logo.split('?d=')[0]}?d=${uniqid()}` : null;
            this.title = (typeof data.title !== "undefined") ? data.title : "";
            this.subtitle = (typeof data.subtitle !== "undefined") ? data.subtitle : "";
            this.position = (typeof data.position !== "undefined") ? parseInt(data.position) : 1;
            this.forward = (typeof data.forward !== "undefined") ? data.forward : null;
            this.isSeen = (typeof data.isSeen !== "undefined") ? data.isSeen : false;
            this.hightlighted = (typeof data.hightlighted !== "undefined") ? data.hightlighted : false;
            this.screens = data.screens.map((s) => new StoryScreen_1.StoryScreen(s)).sort((a, b) => {
                return parseInt(a.position) > parseInt(b.position) ? 1 : 0;
            });
            for (let i in this.screens) {
                if (null === this.screens[i].position) {
                    this.screens[i].position = parseInt(i) + 1;
                }
            }
        }
    }
    nextScreenId() {
        return `${parseInt(this.screens[this.screens.length - 1].id) + 1}`;
    }
}
exports.StoryData = StoryData;
//# sourceMappingURL=StoryData.js.map